import { genRanID } from "../utils/utils";
import { sendMessage } from "./cast-service";
import DBHandler from "../index-db/db-handler";
import { SPORT_BASE, SETTINGS } from "../services/globalVars";
import { get_pre_score } from "../sport/sport-function";

const root = import.meta.env.VITE_MEDIA_HOST;
const dbHandler = DBHandler();
var update_game_clock = false;

const CAST_text_to_speech = (text) => {
   castMSG(text);
}




const CAST_Get_Settings = () => {
   return new Promise(async (resolve) => {
      const result = await castGetSettings();
      resolve(result);
   })
}

const CAST_Rest_Clock = () => {
   update_game_clock = false;
}

const CAST_Update_Screen = async () => {
   try {
      // console.warn('>>>CAST_Update_Screen<<<');
      // console.log('>>> Trigger CAST REFRESH <<<');
      const sync_settings = await dbHandler.load_sync();
      // console.log('sync_settings: ', sync_settings);
      if (sync_settings) {
         const ccfg_id = sync_settings.ccfg_id;
         // console.log('ccfg_id: ', ccfg_id);
         startCastStream(ccfg_id);
         // castSpeechMute(SETTINGS.mute);
         // castVoice(SETTINGS.cast_voice);
         // console.log('>>>>>>>>>>> castBackground: ', SETTINGS.background);
         // castBackground(SETTINGS.background);
         // castBorder(SETTINGS.cast_border_size);
         // castSpeechRate(SETTINGS.cast_speech_rate);
         return;
      }

      console.error('New Cast Settings are being Ignored -- Dev to FIX');



      // console.log('Scoring: ', SPORT_BASE.sport_object.scoring.scoring);
      // console.log('Scoring: ', SPORT_BASE.sport_object.scoring.scoring.get_score_tally);
      // console.log('SPORT_BASE: ', SPORT_BASE.sport_object.scoring.state.match.match_score);
      // new Audio('https://ia802508.us.archive.org/5/items/testmp3testfile/mpthreetest.mp3').play();







      const game_state = SPORT_BASE.sport_object.game_state;
      const warmup_timer = SPORT_BASE.getClock('warmup_timer');
      const between_timer = SPORT_BASE.getClock('between_timer');
      const match_options = SPORT_BASE.sport_object.get_setting_by_key('match_options');
      const playerObj = SPORT_BASE.sport_object.scoring.state.match.players;
      const score_left = SPORT_BASE.sport_object.scoring.state.match.active_game.team_1_score;
      const score_right = SPORT_BASE.sport_object.scoring.state.match.active_game.team_2_score;
      const { team1, team2 } = SPORT_BASE.sport_object.scoring.scoring.get_score_tally;
      const name_left = playerObj.teams[0].name;
      const name_right = playerObj.teams[1].name;
      const serving_player_1 = SPORT_BASE.sport_object.scoring.state.serving.side_state_1.serving_player - 1;
      const serving_player_2 = SPORT_BASE.sport_object.scoring.state.serving.side_state_2.serving_player - 1;
      const serving_side = SPORT_BASE.sport_object.scoring.state.serving.side === 1 ? 'L' : 'R';
      const server_side = SPORT_BASE.sport_object.scoring.state.serving.inner_side === 1 ? 'L' : 'R';
      const server_player = SPORT_BASE.sport_object.scoring.state.serving.player;
      const isDoubles = SPORT_BASE.sport_object.scoring.state.serving.type === 'doubles' ? true : false;
      const p1_icon = typeof playerObj.teams[0].players[0] !== 'undefined' ? playerObj.teams[0].players[0].initial : null;
      const p2_icon = typeof playerObj.teams[1].players[0] !== 'undefined' ? playerObj.teams[1].players[0].initial : null;
      const p3_icon = typeof playerObj.teams[0].players[1] !== 'undefined' ? playerObj.teams[0].players[1].initial : null;
      const p4_icon = typeof playerObj.teams[1].players[1] !== 'undefined' ? playerObj.teams[1].players[1].initial : null;

      let color_left = '';
      let color_right = '';

      try {
         color_left = playerObj.teams[0].players[serving_player_1].color;
         color_right = playerObj.teams[1].players[serving_player_2].color;
         const letter_left = playerObj.teams[0].players[serving_player_1].initial;
         const letter_right = playerObj.teams[1].players[serving_player_2].initial;
         castColor('main', 'L', color_left, letter_left);
         castColor('main', 'R', color_right, letter_right);
      } catch (error) { }
      // console.log('[DEBUG] Serving Player', SPORT_BASE.sport_object.scoring.state.serving);

      castUpdateScore('L', score_left);
      castUpdateScore('R', score_right);


      if (SPORT_BASE.sport_object.sport_name === 'Padel' || SPORT_BASE.sport_object.sport_name === 'Tennis') {
         const { left_pre, right_pre } = get_pre_score();

         let tennisScoreObj = {
            'sportType': SPORT_BASE.sport_object.sport_name,
            'APre': left_pre,
            'BPre': right_pre,
            'server': server_player,
            'preScore': left_pre !== null ? 'true' : 'none',
            'tieBreak': false,
         };

         castUpdateSportData(tennisScoreObj);
         castUpdateIndicator('', '');
      } else if (SPORT_BASE.sport_object.sport_name === 'Pickleball') {
         castUpdateIndicator(serving_side, server_side);
         if (isDoubles) {
            const helper_serving_side = serving_side === 'L' ? SPORT_BASE.sport_object.scoring.state.serving.side_state_1.serving_side : SPORT_BASE.sport_object.scoring.state.serving.side_state_2.serving_side;
            castUpdateSportData({
               'sportType': SPORT_BASE.sport_object.sport_name,
               'side': serving_side,
               'icon': helper_serving_side
            });
         } else {
            castUpdateSportData({
               'sportType': SPORT_BASE.sport_object.sport_name,
               'side': '',
               'icon': ''
            });
         }
      } else {
         castUpdateSportData({ 'sportType': SPORT_BASE.sport_object.sport_name });
         castUpdateIndicator(serving_side, server_side);
         castUpdateServerIcon(1, {
            doubles: isDoubles,
            icons: {
               p1: { icon: p1_icon, sts: server_player === 1 ? true : false, color: color_left },
               p2: { icon: p2_icon, sts: server_player === 2 ? true : false, color: color_right },
               p3: { icon: p3_icon, sts: server_player === 3 ? true : false, color: color_left },
               p4: { icon: p4_icon, sts: server_player === 4 ? true : false, color: color_right },
            }
         });
      }




      castUpdateWins('L', `(${team1})`);
      castUpdateWins('R', `(${team2})`);


      if (update_game_clock === false) {
         update_game_clock = true;
         await SPORT_BASE.loadClocks();
         if (match_options.value === 2) {
            const continuous_clock = SPORT_BASE.getClock('continuous_clock');
            castUpdateClockTimer('start', continuous_clock.value, 1);
            console.log('SENDING CLOCK TIME continuous_clock: ', continuous_clock.value);
         } else {
            const game_clock = SPORT_BASE.getClock('game_clock');
            console.log('SENDING CLOCK TIME: ', game_clock.value);
            castUpdateClockTimer('start', game_clock.value);
         }
      }


      console.log('[DEBUG] game_state: ', game_state);
      if (game_state === 'running') {
         castWarmupScreen('false', 0, '');
         castGameComplete('false', [], 0);
      } else if (game_state === 'warmup') {
         const adArray = {
            ad0: '',
            ad1: '',
            ad2: '',
            ad3: ''
         }
         castGameComplete('false', [], 0);
         castWarmupScreen('true', warmup_timer.value, adArray);
      } else if (game_state === 'game_complete' || game_state === 'match_complete' || game_state === 'init' || game_state === null || game_state === 'end_game_pause') {
         const p1Score = [];
         const p2Score = [];
         const p1ScorePre = [];
         const p2ScorePre = [];
         const match_score = SPORT_BASE.sport_object.scoring.scoring.match_score;
         // const match_score = SPORT_BASE.sport_object.scoring.state.match.match_score;
         // console.log('[DEBUG]: ', SPORT_BASE.sport_object.scoring.scoring);
         // console.log('[DEBUG] match_score: ', match_score);
         for (let a = 0; a < match_score.length; a++) {
            p1Score.push(match_score[a].A);
            p2Score.push(match_score[a].B);
            p1ScorePre.push(match_score[a].A_PRE);
            p2ScorePre.push(match_score[a].B_PRE);
         }

         let score = {
            p1: p1Score,
            p2: p2Score,
            p1p: p1ScorePre,
            p2p: p2ScorePre,
            ad1: 'test.png',
            ad2: 'test.png',
            ad3: 'test.png',
            ad0: 'test.png'
         }

         if (!(score.p1[0] === 0 && score.p2[0] === 0 && score.p1p[0] === 0 && score.p2p[0] === 0)) {
            // console.log('score: ', score);
            if (game_state === 'match_complete' || game_state === 'init' || game_state === null) {
               castGameComplete('match', score, 0);
            } else {
               castGameComplete('game', score, between_timer.value);
            }
         }
      } else {
         castWarmupScreen('false', 0, '');
         castGameComplete('false', [], 0);
      }


      castUpdateADs();

      if (name_left !== '') { castUpdateName('L', name_left); }
      if (name_right !== '') { castUpdateName('R', name_right); }

      castSpeechMute(SETTINGS.mute);
      castVoice(SETTINGS.cast_voice);
      console.log('>>>>>>>>>>> castBackground: ', SETTINGS.background);
      castBackground(SETTINGS.background);
      castBorder(SETTINGS.cast_border_size);
      castSpeechRate(SETTINGS.cast_speech_rate);

      // castUpdateInfoPopUp({ clear: true }); // Remove any previous info pop up
   } catch (error) {
      console.error('CAST_Update_Screen: ', error);
   }
}

const castUpdateADs = async () => {
   const club = await dbHandler.load_club();
   if (typeof club !== 'undefined') {
      let object = {
         'ads': {
            ad0: root + club.ad_1.substring(3),
            ad1: root + club.ad_2.substring(3),
            ad2: root + club.ad_3.substring(3),
            ad3: root + club.club_logo,
         },
      };
      // let adArray = {
      //    ad0: root+club.ad_1.substring(3),
      //    ad1: root+club.ad_2.substring(3),
      //    ad2: root+club.ad_3.substring(3),
      //    ad3: root+club.club_logo,
      // }
      // object.ads = adArray;
      castUpdateSettings(object, null, null);
   }
}

const startCastStream = (ccfg_id) => { castStream(ccfg_id); }


const castMSG = (msg) => { castUpdateText('msg', msg, ''); }
const castBorder = (size) => { castUpdateText('border', size, ''); }
const castVoice = (value) => { castUpdateText('voice', value, ''); }
const castUpdateName = (side, name) => { castUpdateText('name', side, name); }
const castUpdateWins = (side, wins) => { castUpdateText('wins', side, wins); }
const castBackground = (theme) => { castUpdateText('background', theme, ''); }
const castSpeechRate = (value) => { castUpdateText('speechRate', value, ''); }
const castSpeechMute = (value) => { castUpdateText('mute', value, ''); }
const castUpdateScore = (side, score) => { castUpdateText('score', side, score); }
const castColor = (object, side, color, symbol = null) => { castUpdatecolor(object, side, color, symbol); }
const castUpdateIndicator = (side, indicator) => { castUpdateText('indicator', side, indicator); }
const castUpdateServerIcon = (side, details) => { castUpdateText('serverIcon', side, details); }
const castWarmupScreen = (status, time, other) => { castUpdateWarmupScreen(status, time, other); }
const castGameComplete = (status, score = [], time) => { castUpdateGameComplete(status, score, time); }
const castUpdateClockTimer = (status, time = 0, dir = 0) => { castUpdateClock('timer', status, time, dir); }
const castUpdateSportData = (data1 = null, data2 = null, data3 = null) => { castUpdateData(data1, data2, data3); }
const castUpdateInfoPopUp = (data1 = null) => { 
   console.error('TODO: castUpdateInfoPopUp - Change to new Way');

   castUpdateText('infoPopUp', data1); 
   castBackground(SETTINGS.background);
   setTimeout(() => {
      castBackground(SETTINGS.background);
   }, 1000);
}


const castStream = (ccfg_id) => {
   let controlObject = objectBulderText('API', ccfg_id);
   let controlArray = [controlObject];
   sendControlObject(controlArray);
}



const castUpdateText = (object, side, change) => {
   let controlObject = objectBulderText('updateText', object, side, change);
   let controlArray = [controlObject];
   sendControlObject(controlArray);
}

const castUpdateClock = (object, status, time, dir = 0) => {
   let controlObject = objectBulderText('updateClock', object, status, time, dir);
   let controlArray = [controlObject];
   sendControlObject(controlArray);
}

const castUpdateGameComplete = (status, score, time) => {
   let controlObject = objectBulderText('gameComplete', status, score, time);
   let controlArray = [controlObject];
   sendControlObject(controlArray);
}

const castUpdateWarmupScreen = (status, time, other) => {
   let controlObject = objectBulderText('warmup', status, time, other);
   let controlArray = [controlObject];
   sendControlObject(controlArray);
}

const castUpdatecolor = (object, side, color, symbol) => {
   let controlObject = objectBulderText('color', object, side, color, symbol);
   let controlArray = [controlObject];
   sendControlObject(controlArray);
}


const castUpdateData = (object = null, side = null, change = null) => {
   let controlObject = objectBulderText('DATA', object, side, change);
   let controlArray = [controlObject];
   sendControlObject(controlArray);
}

const castUpdateSettings = (object, side, color) => {
   let controlObject = objectBulderText('SETTING', object, side, color);
   let controlArray = [controlObject];
   sendControlObject(controlArray);
}

const castGetSettings = () => {
   return new Promise((resolve) => {
      let controlObject = objectBulderText('GET_SETTING', null, null, null);
      let controlArray = [controlObject];
      const result = sendControlObject(controlArray, true);
      resolve(result);
   })
}

const objectBulderText = (control, object, side = null, change = null, extra = null) => {
   let controlOBJ = {
      control: control,
      object: object,
      side: side,
      change: change,
      extra: extra,
      message_id: genRanID(),
   }
   return controlOBJ;
}

const sendControlObject = (controlArray, await_result = false) => {
   return new Promise(async (resolve) => {
      try {
         // console.log(controlArray);
         const result = await sendMessage({
            data: 'Control',
            control: controlArray
         }, await_result);
         resolve(result);
      } catch (error) {
         resolve(false);
      }
   })
}

export {
   CAST_Update_Screen,
   CAST_text_to_speech,
   CAST_Get_Settings,
   CAST_Rest_Clock,
   castUpdateInfoPopUp
}




